import { render } from "./a_bme.vue?vue&type=template&id=07970cda"
import script from "./a_bme.vue?vue&type=script&lang=js"
export * from "./a_bme.vue?vue&type=script&lang=js"

import "./a_bme.vue?vue&type=style&index=0&id=07970cda&lang=less"
script.render = render

export default script